import React, { useState } from "react";
import { useUser } from "../../context/userContext";
import { poster } from "../../utils/axios";

const Feedback = ({ examId, userId }) => {
  const [feedbacks, setFeedbacks] = useState([]);
  const [rating, setRating] = useState(5);
  const [review, setReview] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { user } = useUser();

  const submitFeedback = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccess("");

    try {
      const response = await poster(`${process.env.REACT_APP_API_URL}/feedback`, {
        exam: examId,
        user: userId,
        rating,
        review,
      });

      setFeedbacks([...feedbacks, response.data]); // Update state with new feedback
      setSuccess("Feedback submitted successfully!");
      setRating(5);
      setReview("");
    } catch (err) {
      setError(err.response?.data?.error || "Failed to submit feedback.");
    }

    setLoading(false);
  };

  return (
    <div className="w-full max-w-4xl mx-auto p-6 bg-white shadow-lg rounded-lg mt-10">
      <div style={{ textAlign: "center", marginBottom: "20px" }}>
        <h2 className="text-2xl font-bold text-gray-800 mb-4">How was your exam?</h2>
        <span className="text-gray-800 mb-4">Don't be lazy and give your valuable feedback</span>
      </div>

      {/* Alerts */}
      {error && <p className="text-red-500 text-sm mb-2">{error}</p>}
      {success && <p className="text-green-500 text-sm mb-2">{success}</p>}

      {/* Feedback Form */}
      <form onSubmit={submitFeedback} className="bg-gray-100 p-4 rounded-lg shadow-md">
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Review:</label>
          <textarea
            className="w-full mt-1 p-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-400"
            value={review}
            onChange={(e) => setReview(e.target.value)}
            maxLength={1000}
            placeholder="Write your review here..."
            rows={4}
          />
        </div>

        <button
          type="submit"
          className="w-full bg-blue-500 text-white py-2 px-4 rounded-md hover:bg-blue-600 transition-all"
          disabled={loading}
        >
          {loading ? "Submitting..." : "Submit Feedback"}
        </button>
      </form>
    </div>
  );
};

export default Feedback;
